import React from "react"
export function DownArrow(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M2 10.869l7.446 6.916a.821.821 0 001.01.077l.098-.077L18 10.869l-1.108-1.106-6.106 5.67.02-13.43L9.21 2l-.02 13.414-6.082-5.65L2 10.868z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__down-arrow"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
